<template>
  <VueTagsInput
    ref="input"
    v-model="search"
    :tags="tags"
    :autocomplete-min-length="0"
    :autocomplete-items="filteredStatuses"
    :add-only-from-autocomplete="true"
    placeholder="Account status..."
    class="status-tags-input"
    v-on="$listeners"
    @tags-changed="onTagsChanged"
  />
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import VueTagsInput from '@johmun/vue-tags-input'
import { AccountStatusCondition } from '@/views/MessageCenter/condition.js'
import { matchesQuery } from '@/utils/autocompleteFilter'

@Component({
  components: {
    VueTagsInput
  }
})
export default class AccountStatusFilter extends Vue {
  search = ''
  tags = []

  get statusOptions() {
    return Object.entries(AccountStatusCondition.Labels).map(
      ([status, text]) => ({ text, status })
    )
  }

  get selectedStatuses() {
    return this.tags.map(t => t.status).filter(Boolean)
  }

  get filteredStatuses() {
    const selected = this.selectedStatuses

    return this.statusOptions
      .filter(option => !selected.includes(option.status))
      .filter(option => matchesQuery(this.search, option.text))
  }

  clear() {
    this.search = ''
    this.tags = []
    this.$emit('status-changed', [])
  }

  onTagsChanged(newTags) {
    this.tags = newTags
    this.$emit('status-changed', this.selectedStatuses)
  }

  setStatuses(values) {
    if (!values?.length) {
      this.tags = []

      return
    }
    this.tags = this.statusOptions.filter(option =>
      values.includes(option.status)
    )
  }
}
</script>

<style lang="scss" scoped>
.status-tags-input {
  flex: 1;
  min-width: 0;
}
.status-tags-input ::v-deep .ti-tag.ti-valid {
  &:not(.ti-deletion-mark) {
    background-color: $button-blue;
    border-color: $button-blue;
    color: #fff;
  }
}
.status-tags-input ::v-deep .ti-autocomplete {
  max-height: 150px;
  background-color: #fff !important;
  border: 1px solid #ced4da;
  border-top: none;
  color: #212529;
  .ti-item {
    color: #212529;
    > div {
      padding: 6px 10px;
    }
    &.ti-selected-item {
      background-color: $button-blue;
      color: #fff;
    }
  }
}
</style>
